import { render, staticRenderFns } from "./product-generic-zero-brands.modal.vue?vue&type=template&id=122436db&scoped=true&"
import script from "./product-generic-zero-brands.modal.vue?vue&type=script&lang=js&"
export * from "./product-generic-zero-brands.modal.vue?vue&type=script&lang=js&"
import style0 from "./product-generic-zero-brands.modal.vue?vue&type=style&index=0&id=122436db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122436db",
  null
  
)

export default component.exports